import { ComponentBread, ComponentHeader, StyledCreate } from "@components";
import { PATH_COUPON_LIST, PATH_CREATE_CDIC_PROGRAM } from "@configs";
import { CdicProgramForm } from "@modules/coupon/Program";
import { useProgramDetail } from "@utils";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

export const PageCreateCdicProgram = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const { data: coupon } = useProgramDetail(id);

  const data = [
    {
      title: <a href={PATH_COUPON_LIST}>{t("page.coupon_management")}</a>,
    },
    {
      title: <a href={"/"}>{t("page.selected_program_name")}</a>,
    },
    {
      title: <a href={PATH_CREATE_CDIC_PROGRAM}>{t("page.create_program")}</a>,
    },
  ];

  return (
    <>
      <ComponentHeader title={t("page.create_coupon_family")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <CdicProgramForm coupon={coupon} />
      </StyledCreate>
    </>
  );
};
